import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'productList',
    title: '产品列表',
    icon: 'el-icon-menu',
    component: () => import('../views/productList.vue'),
  },
  {
    path: '/product/:id',
    name: 'product',
    title: '添加产品',
    icon: 'el-icon-s-claim',
    component: () => import('../views/productCustom.vue'),
  },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // assetsPublicPath: './',
});

export default router;
